define([
    "jquery",
    "underscore",
    "backbone",
    "models/quote_model",
    "templates/trading/forex_quote_list_item.html"
], function($, _, Backbone, Quote, quoteListTemplate) {
    return Backbone.View.extend({
        el: '#content_layout',

        events:{
        },

        initialize: function(){
        }

    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/trading/forex_view.js
// module id = 52
// module chunks = 0